import { SecondaryNavigationItem } from 'src/app/core';

/**
 * Middle Navigation for chat integration
 */
export const middleNavigation: SecondaryNavigationItem[] = [
	{
		id: 'salesforce',
		label: 'lup.subnav.lup_salesforce_settings',
		url: '/settings/integrations/salesforce',
		permissionCheck: ({ stateService, userService }) => {
			const { allow_sales_force } = stateService.portalMeta;
			return userService.isAdmin() && allow_sales_force;
		},
		external: true
	},
	{
		id: 'lrs',
		label: 'lup.subnav.lup_lrs_settings',
		url: '/settings/integrations/lrs',
		external: true,
		permissionCheck: ({ stateService, userService }) => {
			const { allow_lrs } = stateService.portalMeta;
			return userService.isAdmin() && allow_lrs;
		}
	},
	{
		id: 'webinar',
		label: 'lup.subnav.lup_webinar_settings',
		url: '/settings/integrations/webinars',
		external: true,
		permissionCheck: ({ stateService, userService }) => {
			const { allow_webinars } = stateService.portalMeta;
			return userService.isAdmin() && allow_webinars;
		}
	},
	{
		id: 'api',
		label: 'lup.subnav.lup_api_settings',
		url: '/settings/integrations/api',
		external: true,
		permissionCheck: ({ stateService, userService }) => {
			const { allow_api } = stateService.portalMeta;
			return userService.isAdmin() && allow_api;
		}
	},
	{
		id: 'oauth',
		label: 'OAuth',
		url: '/settings/integrations/oauth',
		external: false,
		permissionCheck: ({ stateService, userService }) => {
			const { allow_api } = stateService.portalMeta;
			const { oauth_enabled } = stateService.portalMeta;
			return userService.isAdmin() && allow_api && oauth_enabled;
		}
	},
	{
		id: 'oidc',
		label: 'OIDC',
		url: '/settings/integrations/oidc',
		external: true,
		permissionCheck: ({ stateService, userService }) => {
			const { oidc_enabled } = stateService.portalMeta;
			return userService.isAdmin() && oidc_enabled;
		}
	},
	{
		id: 'webhook',
		label: 'lup.subnav.lup_webhooks_settings',
		url: '/settings/integrations/webhooks',
		permissionCheck: ({ stateService, userService }) => {
			const { allow_webhooks } = stateService.portalMeta;
			return userService.isAdmin() && allow_webhooks;
		},
		external: true
	},
	{
		id: 'webhook-v2',
		label: 'lup.subnav.lup_new_webhook_settings',
		url: '/settings/integrations/webhooks-v2',
		permissionCheck: ({ stateService, userService }) => {
			const { new_webhooks } = stateService.portalMeta;
			return userService.isAdmin() && new_webhooks;
			// TODO: move to JRIMA flag
		},
		external: true
	},
	{
		id: 'saml',
		label: 'lup.subnav.lup_saml_settings',
		url: '/settings/integrations/saml',
		permissionCheck: ({ stateService, userService }) => {
			const { allow_saml } = stateService.portalMeta;
			return userService.isAdmin() && allow_saml;
		},
		external: true
	},
	{
		id: 'sqsso',
		label: 'lup.subnav.lup_sqsso_settings',
		url: '/settings/integrations/sqsso',
		external: true,
		permissionCheck: ({ stateService, userService }) => {
			const { allow_sqsso } = stateService.portalMeta;
			return userService.isAdmin() && allow_sqsso;
		}
	},
	{
		id: 'recaptcha',
		label: 'lup.subnav.lup_recaptcha_settings',
		url: '/settings/integrations/recaptcha',
		permissionCheck: ({ stateService, userService }) => {
			const { allow_recaptcha } = stateService.portalMeta;
			return userService.isAdmin() && allow_recaptcha;
		},
		external: true
	},
	{
		id: 'chat_integrations',
		label: 'lup.subnav.lup_chat_integrations_settings',
		url: '/settings/integrations/chat-integrations',
		permissionCheck: ({ stateService, userService }) => {
			const { allow_chat_integrations } = stateService.portalMeta;
			return userService.isAdmin() && allow_chat_integrations;
		},
		external: false
	},
	{
		id: 'content_embed',
		label: 'lup.subnav.lup_content_embed_settings',
		url: '/settings/content-embed',
		permissionCheck: ({ stateService, userService }) => {
			const { allow_content_embed } = stateService.portalMeta;
			return userService.isAdmin() && allow_content_embed;
		},
		external: false
	}
];
